import ToolShell, { OutputBlock, HookRow } from "@/pages/tools/ToolShell";

export default function EmulationMode() {
  return (
    <ToolShell
      testid="tool-emulation-page"
      eyebrow="Tool" toolKey="emulation"
      title="Emulation Mode"
      subtitle="Drop a reel link, caption or screenshot description. We reverse-engineer the structure and rebuild it in your niche - never the wording."
      endpoint="/tools/emulation"
      transformPayload={(s) => ({ ...s, screenshot_file_id: s.screenshot?.file_id || null })}
      fields={[
        { key: "reference", label: "Reel link, caption, or full description", type: "textarea", rows: 5, required: true, placeholder: "Paste link or describe the reel: visuals, captions, hook, what it did well." },
        { key: "screenshot", label: "Reference screenshot (optional)", type: "file", accept: "image/*", help: "Upload a screenshot of the reel cover or a key frame. We'll pass it into the analysis." },
        { key: "screenshot_note", label: "Anything specific from the screenshot?", type: "textarea", rows: 3, placeholder: "e.g. The overlay says 'Stop scuba diving like this' in white text top-third." },
      ]}
      renderOutput={(o) => (
        <>
          {o.analysis && (
            <OutputBlock testid="output-analysis" label="Analysis">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-[14.5px]">
                {Object.entries(o.analysis).map(([k, v]) => (
                  <div key={k}><span className="dms-label">{k.replace(/_/g, " ")}</span><div className="mt-1">{v}</div></div>
                ))}
              </div>
            </OutputBlock>
          )}
          {o.rebuild && (
            <>
              <OutputBlock testid="output-rebuild-concept" label="Rebuilt Concept" copyValue={o.rebuild.reel_concept}>{o.rebuild.reel_concept}</OutputBlock>
              <OutputBlock testid="output-rebuild-hooks" label="Hooks" copyValue={(o.rebuild.hooks || []).join("\n")}>
                {(o.rebuild.hooks || []).map((h, i) => <HookRow key={i} hook={h} />)}
              </OutputBlock>
              {o.rebuild.structure && (
                <OutputBlock testid="output-rebuild-structure" label="Structure">
                  <div className="space-y-3 text-[14.5px]">
                    {Object.entries(o.rebuild.structure).map(([k, v]) => (
                      <div key={k}><span className="dms-label">{k.replace(/_/g, " ")}</span><div className="mt-1">{v}</div></div>
                    ))}
                  </div>
                </OutputBlock>
              )}
              <OutputBlock testid="output-rebuild-caption" label={`Caption (${(o.rebuild.caption || "").length} chars)`} copyValue={o.rebuild.caption}>
                <div className="whitespace-pre-wrap leading-relaxed">{o.rebuild.caption}</div>
              </OutputBlock>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <OutputBlock testid="output-rebuild-cta" label="CTA" copyValue={o.rebuild.cta}>{o.rebuild.cta}</OutputBlock>
                <OutputBlock testid="output-rebuild-pinned" label="Pinned Comment" copyValue={o.rebuild.pinned_comment}>{o.rebuild.pinned_comment}</OutputBlock>
              </div>
            </>
          )}
        </>
      )}
    />
  );
}
